/* eslint-disable import/extensions */

// Services Img Imports
import Web from '../assets/images/Services/Web.png';
import Mobile from '../assets/images/Services/Mobile.png';
import UIUX from '../assets/images/Services/Design.png';

// Portfolio Img Imports

// Advantages
import Communicative from '../assets/images/Advantages/Communicative.png';
import Collaborative from '../assets/images/Advantages/Collaborative.png';
import Management from '../assets/images/Advantages/Management.png';
import Favorite from '../assets/images/Advantages/Favorite.png';

// Testimonials
import Sasha from '../assets/images/Testimonials/Sasha.jpg';
import Reiner from '../assets/images/Testimonials/Reiner.jpg';
import Kruger from '../assets/images/Testimonials/Kruger.jpg';

// TeamMembers
import CEO from '../assets/images/TeamMembers/CEO.jpg';
import HRD from '../assets/images/TeamMembers/HRD.jpg';
import Finance from '../assets/images/TeamMembers/Finance.jpg';
import ProjectManager from '../assets/images/TeamMembers/Project-manager.jpg';
import Frontend1 from '../assets/images/TeamMembers/Frontend1.jpg';
import Frontend2 from '../assets/images/TeamMembers/Frontend2.jpg';
import Backend1 from '../assets/images/TeamMembers/Backend1.jpg';
import Backend2 from '../assets/images/TeamMembers/Backend2.jpg';
import Mobile1 from '../assets/images/TeamMembers/Mobile1.jpg';
import Mobile2 from '../assets/images/TeamMembers/Mobile2.jpg';
import UIUX1 from '../assets/images/TeamMembers/UIUX1.jpg';
import UIUX2 from '../assets/images/TeamMembers/UIUX2.jpg';

export const Services = [
  {
    title: 'Web Development',
    imageUrl: Web,
    animation: 'left',
  },
  {
    title: 'Mobile App Development',
    imageUrl: Mobile,
    animation: 'up',
  },
  {
    title: 'Consultancy Services',
    imageUrl: Web,
    animation: 'right',
  },
  {
    title: 'UI/UX Design',
    imageUrl: UIUX,
    animation: 'right',
  },
  {
    title: 'Recruitment Services',
    imageUrl: Web,
    animation: 'right',
  },
];

export const Portfolios = [
  {
    id: 'p01',
    title: 'Lamarhealth App',
    imageUrl: "https://inzmam.web.app/img/lamarhealth-main.png",
    type: 'Web and Mobile Apps',
    responsibility: [
      'Next JS',
      'React JS',
      'Mobile Api',
      'UI/UX Design',
    ],
    credit: 'https://inzmam.web.app/img/lamarhealth-main.png',
    projectDetails: "Developed frontend and backend components for their web/mobile application using React/Next.",
  },
  {
    id: 'p02',
    title: 'Treemendous',
    imageUrl: "https://inzmam.web.app/img/treemendous-main.png",
    type: 'Web',
    responsibility: [
      'Next JS',
      'React JS',
      'UI/UX Design',
    ],
    credit: 'https://inzmam.web.app/img/treemendous-main.png',
    projectDetails: "This is a plant and tree services provider for your garden. They providing several other services related to managing and decorating garden or office space.",
  },
  {
    id: 'p03',
    title: 'Saveo',
    imageUrl: "https://inzmam.web.app/img/saveo-main.png",
    type: 'Web',
    responsibility: [
      'Web Development',
    ],
    credit: 'https://inzmam.web.app/img/saveo-main.png',
    projectDetails: "This is an healthcare product, which helps suppliers and distributors of medicines supply chain.",
  },
  {
    id: 'p04',
    title: 'BDA Unani',
    imageUrl: "https://inzmam.web.app/img/bdaunani-main.png",
    type: 'Web App',
    responsibility: [
      'Web Development',
      'UI/UX Design',
    ],
    credit: 'https://inzmam.web.app/img/bdaunani-main.png',
    projectDetails: "This project aim to help doctors, students, org members to find medicines and use community features . There is diffrent roles for users, according to which they can use feature and get Subscription to be part of association.",
  },
];

export const Advantages = [
  [{
    title: 'Communicative',
    description: 'We communicate our project ideas and progress to make it clear.',
    imageUrl: Communicative,
  },
  {
    title: 'Management',
    description: 'We manage our project properly to make our project done well.',
    imageUrl: Management,
  }],
  [{
    title: 'Collaborative​',
    description: 'Our team are very collaborative to make our project done well.',
    imageUrl: Collaborative,
  },
  {
    title: 'Favorite',
    description: "We've did so many project and all of our client love it.",
    imageUrl: Favorite,
  }],
];
export const Testimonials = [
  {
    id: 1,
    name: 'Sasha Rose',
    company: 'Owner, Surveyor Corps',
    testimoni: 'Thanks for Starlink Lab, you guys are the best! Keep up the great work!',
    imageUrl: Sasha,
  },
  {
    id: 2,
    name: 'Kruger Khan',
    company: 'Director, Shultan Oil',
    testimoni: 'I just wanted to let you know that it’s been great working with Starlink Lab.',
    imageUrl: Kruger,
  },
  {
    id: 3,
    name: 'Reiner John',
    company: 'CEO, Marley CO',
    testimoni: 'Starlink Lab is so great. Thank you so much for a job well done.',
    imageUrl: Reiner,
  },
];

export const TeamMembers = [
  {
    name: 'Rach David',
    position: 'CEO',
    imageUrl: CEO,
  },
  {
    name: 'Pauline Sydney',
    position: 'HRD',
    imageUrl: HRD,
  },
  {
    name: 'Granger Watterson',
    position: 'Finance',
    imageUrl: Finance,
  },
  {
    name: 'Tom Jimmy',
    position: 'Project Manager',
    imageUrl: ProjectManager,
  },
  {
    name: 'Jim Hendrix',
    position: 'Front-end Developer',
    imageUrl: Frontend1,
  },
  {
    name: 'Calvin Max',
    position: 'Front-end Developer',
    imageUrl: Frontend2,
  },
  {
    name: 'Hawkins Jim',
    position: 'Back-end Developer',
    imageUrl: Backend1,
  },
  {
    name: 'Don Bizaro',
    position: 'Back-end Developer',
    imageUrl: Backend2,
  },
  {
    name: 'Bill Markinson',
    position: 'Mobile Developer',
    imageUrl: Mobile1,
  },
  {
    name: 'Igor Kavarov',
    position: 'Mobile Developer',
    imageUrl: Mobile2,
  },
  {
    name: 'Freddie Curl',
    position: 'UI/UX Designer',
    imageUrl: UIUX2,
  },
  {
    name: 'Monica Lovegood',
    position: 'UI/UX Designer',
    imageUrl: UIUX1,
  },
];
